module.exports = __webpack_public_path__ + "img/4-1.d21b5377.png";